export default __webpack_public_path__ + "static/media/0.cbdaeb94.mp3";